import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Padlock = (props) => (
  <SvgIcon width="11" height="15" viewBox="0 0 11 15" {...props}>
    <path d="M9.5 5.33317H8.83333V3.99984C8.83333 2.15984 7.34 0.666504 5.5 0.666504C3.66 0.666504 2.16666 2.15984 2.16666 3.99984V5.33317H1.5C0.766664 5.33317 0.166664 5.93317 0.166664 6.6665V13.3332C0.166664 14.0665 0.766664 14.6665 1.5 14.6665H9.5C10.2333 14.6665 10.8333 14.0665 10.8333 13.3332V6.6665C10.8333 5.93317 10.2333 5.33317 9.5 5.33317ZM5.5 11.3332C4.76666 11.3332 4.16666 10.7332 4.16666 9.99984C4.16666 9.2665 4.76666 8.6665 5.5 8.6665C6.23333 8.6665 6.83333 9.2665 6.83333 9.99984C6.83333 10.7332 6.23333 11.3332 5.5 11.3332ZM7.56666 5.33317H3.43333V3.99984C3.43333 2.85984 4.36 1.93317 5.5 1.93317C6.64 1.93317 7.56666 2.85984 7.56666 3.99984V5.33317Z" />
  </SvgIcon>
);
export default Padlock;



// WEBPACK FOOTER //
// ./src/common/icons/Padlock/index.tsx